/* ════════════════════════════════════════════════════════════
   قنوات يوتيوب للمراجعة — من ملفّك

   ⚠️ **الأسماء منقولة حرفياً** ولم أُضف قناة واحدة من عندي.

   والروابط **روابط بحث في يوتيوب بالاسم** لا روابط قنوات مباشرة —
   كما في أداتك الأصلية. وهذا أسلم فعلاً: رابط القناة قد يتغيّر أو
   تُحذف القناة فيصير الرابط ميّتاً، أمّا البحث بالاسم فيصل دائماً إلى
   ما هو موجود اليوم.

   ونقول ذلك للزائر صراحةً في الصفحة بدل أن نُوهمه بروابط مباشرة.
════════════════════════════════════════════════════════════ */

export interface ChannelCategory {
  category: string;
  channels: string[];
}

export const CHANNELS: ChannelCategory[] = [
  {
    "category": "الرياضيات",
    "channels": [
      "الأستاذ عبد الباسط",
      "الدكتور السكي داود",
      "الأستاذ نور الدين",
      "الأستاذ كساسي",
      "Infinity Math (أنغينيتي)",
      "Prof Boucif",
      "الأستاذ مهاية رياضيات",
      "الأستاذ جوفر"
    ]
  },
  {
    "category": "الفيزياء",
    "channels": [
      "الأستاذ طيايبة عبد الرزاق",
      "محمد الأمين زدون",
      "الأستاذ أحمد ترير",
      "الأستاذ عبد اللطيف",
      "الأستاذ عبد الله",
      "الأستاذ أحمد شعلال"
    ]
  },
  {
    "category": "العلوم الطبيعية",
    "channels": [
      "الأستاذة كتفي شريف زينة",
      "الأستاذ مصطفى بدد",
      "الأستاذ شاوش",
      "الأستاذ طلحي",
      "أيوب للعلوم",
      "خيرة فليتي",
      "الأستاذ بن عثمان"
    ]
  },
  {
    "category": "الأدب العربي",
    "channels": [
      "الأستاذ بوبكر مبروك",
      "الأستاذ خالد حماش",
      "الأستاذ حيقون أسامة",
      "الأستاذ بلخير أسامة",
      "اقتدار"
    ]
  },
  {
    "category": "العلوم الإسلامية",
    "channels": [
      "الأستاذة بوسعادي",
      "الأستاذ شمس الدين",
      "الأستاذ سعدون شعيب",
      "الأستاذ موسلي"
    ]
  },
  {
    "category": "الفلسفة",
    "channels": [
      "الأستاذ خليل سعيداني",
      "الأستاذ حمداش عبد الحق",
      "الأستاذ عادل مقرود",
      "الأستاذ هواري"
    ]
  },
  {
    "category": "التاريخ والجغرافيا",
    "channels": [
      "الأستاذ بورنان",
      "قنشوبة Officiel",
      "أمين قزام",
      "محمد العروق",
      "El Amine School",
      "منير العمري"
    ]
  },
  {
    "category": "اللغة الإنجليزية",
    "channels": [
      "Nasri Anglais",
      "Mr.Mansouri",
      "الأستاذ جيار",
      "الأستاذ أمين",
      "عبد المؤمن"
    ]
  },
  {
    "category": "اللغة الفرنسية",
    "channels": [
      "الأستاذ منير شبوة",
      "الفرنسية لمن يرغب",
      "Sally Français",
      "الأستاذة بوغدادة",
      "الأستاذ أسامة فرنسية"
    ]
  },
  {
    "category": "الهندسة المدنية",
    "channels": [
      "الأستاذ فيلالي",
      "الأستاذ كمال مخلوفي",
      "الأستاذ عبد الرحمان"
    ]
  },
  {
    "category": "الهندسة الكهربائية",
    "channels": [
      "العلامة الكاملة في الهندسة الكهربائية",
      "الميسر في الكهرباء",
      "الأستاذة لعروسي",
      "الأستاذ كناز زكرياء",
      "بن عربية امحمد",
      "جادل عبد المجيد"
    ]
  },
  {
    "category": "هندسة الطرائق",
    "channels": [
      "الأستاذ رهواني سفيان",
      "محمد الهاشمي",
      "بروالي هاني",
      "بن قداش"
    ]
  },
  {
    "category": "الهندسة الميكانيكية",
    "channels": [
      "رابحي أكرم وليد",
      "رحاب قلعي",
      "Mufid Génie Mécanique"
    ]
  },
  {
    "category": "قنوات شاملة لجميع المواد",
    "channels": [
      "Bac Feljib",
      "Cour DZ",
      "مدرسة مرسي"
    ]
  }
];

/** رابط بحث يوتيوب — نفس ما تفعله `ySearch` في ملفّك */
export function searchUrl(name: string): string {
  return `https://www.youtube.com/results?search_query=${encodeURIComponent(name)}`;
}

export const TOTAL_CHANNELS = CHANNELS.reduce((n, c) => n + c.channels.length, 0);
